var exports = {
  "V6": "QuickSetup__V9CPfa",
  "Y9": "Header__eC_mGV",
  "hE": "Title__HDKzry",
  "Hi": "OrSeparator__nck6TA",
  "eD": "CloneInput__2ntWOx",
  "hI": "Intro__VCT9Or",
};

module.exports = exports;
